import React, { Component } from 'react';
import { AutodiagnosticoContentPanel } from './AutodiagnosticoContentPanel';
import AuthService from '../../services/AuthService.js';
import FetchService from '../../services/FetchService.js';


export class AutodiagnosticoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cuestionario: {
                id: 1,
                empleado_id: 1,
                usuario_id: 1,
                nombre: "Cargando...",
                preguntas: [
                    //{ id: 1, value: "Ha estado en contacto directo o cuidando a un paciente positivo para covid 19", isChecked: false },
                    //{ id: 2, value: "Ha estado en un area afectada por el Covid19", isChecked: false },
                    //{ id: 3, value: "Ha tenido o tiene Dificultad para respirar", isChecked: false },
                    //{ id: 4, value: "Esta Presentando dolores de cabeza", isChecked: false }
                ]
            },
            empleado: {
                id: null,
                identificacion: null,
                nombre: null
            }
        }

        this.intputIdentificacion = null;

        //events
        this.onSubmit = this.onSubmit.bind(this);
        this.buttonCancel_onClick = this.buttonCancel_onClick.bind(this);
        this.inputIdentificacion_onChange = this.inputIdentificacion_onChange.bind(this);
        this.inputIdentificacion_onKeyPress = this.inputIdentificacion_onKeyPress.bind(this);
        this.buttonIdentificacion_onClick = this.buttonIdentificacion_onClick.bind(this);
    }
    componentWillMount() {
    }
    cargarPreguntas(datos) {
        if (datos) {
            datos.empleado_id = '' + AuthService.getToken().auxId;
        }
        this.setState({
            cuestionario: datos
        });
        let me = this;

    }
    cargarCuestionarioServidor() {
        var me = this; 
        const data = "1";
        fetch('api/Autodiagnostico/CargarCuestionario?id=2', {
            method: 'GET'
        })
            .then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                else {
                    throw "Error en la llamada Ajax";
                }
            })
            .then(function (item) {
                me.cargarPreguntas(item);
            })
            .catch(function (err) {
                alert(err);
            });
    }
    cargarPermisos(permisos) {
        if (!permisos.AllowAutoevaluation) {
            this.props.history.push('/home');
        } else { 
            this.cargarCuestionarioServidor();
        }
    }
    cargarPermisosError(err) {
        this.props.history.push('/home');
    }
    crearIdentificacion() {
        if (!AuthService.getToken().auxId) {
            return (
                <div style={{ textAlign: 'left !important' }}>
                    <div class="form-group">
                        <div class="form-row">
                            <label class="col-md-3" style={{ textAlign: 'left !important' }}>Identificación</label>
                            <div class="input-group col-md-9">
                                <input name="Identificacion" type="text" className="form-control" autoFocus value={this.state.empleado.identificacion} onChange={this.inputIdentificacion_onChange} onKeyPress={this.inputIdentificacion_onKeyPress} ref={(input) => this.intputIdentificacion = input} style={{ autoComplete: 'random-string', autoFill: 'off' }} />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" title="Buscar" onClick={this.buttonIdentificacion_onClick}>
                                        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style={{ float: 'left !important' }}>
                        <div className="form-row" style={{ float: 'left !important' }}>
                            <label class="col-md-3" style={{ float: 'left !important' }}>Nombre</label>
                            <label name="Nombre" type="text" className="col-md-9" style={{ float: 'left !important' }}>{this.state.empleado.nombre} </label>
                        </div>
                    </div>
                </div>
            )
        }
    }
    buscarEmpleadoPorIdentificacion() {
        var me = this;
        var url = 'api/Autodiagnostico/BuscarEmpleadoPorIdentificacion?identificacion=' + this.state.empleado.identificacion;
        FetchService.send(url, 'GET', null, me.buscarEmpleado.bind(me), me.buscarEmpleadoError.bind(me));
    }
    buscarEmpleado(datos) {
        let empleado = this.state.empleado;
        let cuestionario = this.state.cuestionario;
        if (datos) {
            empleado = datos;
            cuestionario.empleado_id = datos.id;
        } else {
            alert("No existe el empleado con la identificación " + empleado.identificacion + ".")
            empleado.id = '0';
            empleado.identificacion = '';
            empleado.nombre = '';
            cuestionario.empleado_id = '0';
        }
        this.setState({
            cuestionario: cuestionario,
            empleado: empleado
        });
    }
    buscarEmpleadoError(err) {
        alert(err);
    }
    buttonCancel_onClick() {
        this.props.history.push('/');
    }
    inputIdentificacion_onChange(event) {
        var empleado = this.state.empleado;
        empleado.identificacion = event.target.value
        this.setState({
            empleado: empleado
        });
    }
    inputIdentificacion_onKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.buscarEmpleadoPorIdentificacion();
        }
    }
    buttonIdentificacion_onClick(event) {
        event.preventDefault();
        this.buscarEmpleadoPorIdentificacion();
    }
    onSubmit(e) {
        var me = this;
        e.preventDefault();

        let diligenciado = this.state.cuestionario;

        if (!(diligenciado.empleado_id > 0)) {
            this.intputIdentificacion.focus();
            alert("Por favor ingrese el empleado.");
            return;
        }

        const data = JSON.stringify(diligenciado);
        fetch('api/Autodiagnostico/EnviarCuestionario', {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                }
                else {
                    throw "Ha ocurrido un error enviando el formulario, por favor revise que la información sea correcta e inténtelo nuevamente.";
                }
            })
            .then(function (texto) {
                me.props.history.push('/autodiagnosticoconfirmacion');
            })
            .catch(function (err) {
                alert(err);
            });
    }
    componentDidMount() { 
        var url = 'api/Sesion/CargarPermisos';
        FetchService.send(url, 'GET', null, this.cargarPermisos.bind(this), this.cargarPermisosError.bind(this));
    }
    render() {
        return (
            <div>
                <div className="contenedor-form-principal">
                    <div className="autodiagnostico-contenedor-principal">
                        <div class="jumbotron">
                            <center>
                                <h3>{this.state.cuestionario.nombre}</h3>
                            </center>
                            <small>Agradecemos diligencie este formulario de manera clara y veraz.</small> <br />
                            <small>Marque la casilla en caso afirmativo.</small>
                        </div>
                        <form id="LoginForm" onSubmit={this.onSubmit}>
                            {this.crearIdentificacion()}
                            <div>
                                <AutodiagnosticoContentPanel cuestionario={this.state.cuestionario} />
                            </div>
                            <br />
                            <center>
                                <button type="submit" className="btn btn-primary btn-sm">Aceptar</button>
                                &nbsp;
                                <button className="btn btn-secondary btn-sm" onClick={this.buttonCancel_onClick}>Cancelar</button>
                            </center>
                        </form>
                    </div>
                </div>
                <br />
            </div >
        );
    }
}
